import React from "react";
import Character1Box from "./Character1Box.js"
import Character2Box from "./Character2Box.js"
import Character3Box from "./Character3Box.js"
import Character4Box from "./Character4Box.js"

class CharacterBox extends React.Component {
  state = { svg: null };

  componentDidMount() {
    const svgSupport =
      !!document.createElementNS &&
      !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
        .createSVGRect;
    if (svgSupport) {
      this.setState({
        svg: "svg"
      });
    } else {
      this.setState({
        svg: "png"
      });
    }
  }
  render() {
    return (
      <div
        className={
          "option character-illustration-wrapper character-box " +
          this.state.svg
        }
      >
        {this.props.characterReference === "character-1" && <Character1Box/>}
        {this.props.characterReference === "character-2" && <Character2Box/>}
        {this.props.characterReference === "character-3" && <Character3Box/>}
        {this.props.characterReference === "character-4" && <Character4Box/>}
        <svg className={"character-background character-box-background"} />
      </div>
    );
  }
}

export default CharacterBox;
